<div [dir]="dir">
    <div class="flex-container" >
    
    <div class="login-side">
        <div class="form-container">

            <h2 class="heading">{{"Login.title"|translate}} </h2>
                            <p class="description-login">{{"Login.description"|translate}}</p>

      <div *ngIf="isNafathLogin">
              <form [formGroup]="loginForm" (ngSubmit)="nafathLogin()">
    <div class="holder-input">
             <div class="input-wrapper">
                <input type="text" [placeholder]=" 'Login.id_placeholder'|translate " class="input-field form-control" maxlength="10" formControlName="nationalId" >
            </div>

            <button class="submit-btn" type="submit" [disabled]="!loginForm.valid ">
                {{'Login.submit_button'|translate}}
            </button>
           </div>
            </form>
      </div>
      <div *ngIf="!isNafathLogin">
        <div class="border random  rounded p-4    my-4  mx-auto text-center" style="width: 128px;">
          {{ 34 }}
        </div>
        <p class="description-login">
 {{'Login.nafath_instruction'|translate}}
        </p>
        <button
          pButton
          pRipple
          (click)="reset()"
          
          class="submit-btn"
        >{{'Login.cancel_button'|translate}}</button>
      </div>
       <button class="langButton" (click)="changeLanguage()">{{"Login.lang"|translate}}</button>

            </div>
    </div>

    <div class="visual-side">
        <img src="../../../../assets/images/login-illustration.png" alt="Login Background" class="illustration" />
        <img src="../../../../assets/images/MC-logo.png" alt="Ministry Logo" class="overlay-logo" />
    </div>

</div>
</div>